import Paper from "@material-ui/core/Paper";
import Radio from "@material-ui/core/Radio";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import TableSortLabel from "@material-ui/core/TableSortLabel";
import MyTypography from "@saleor/components/MyTypography";
import React, { useCallback, useState } from "react";

import useStyles from "./styles";

interface DataSortTableProps {
  selected: string;
  headCells: Array<{ field: string; headerName: string; width: number }>;
  rows: Array<{ [key: string]: any }>;
  onRowSelect: (selectedRowIndex: number) => void;
  sortField: string;
  boldFields?: string[];
}

const DataSortTable: React.FC<DataSortTableProps> = ({
  headCells,
  rows,
  onRowSelect,
  sortField,
  selected
}) => {
  const classes = useStyles();

  const [orderBy, setOrderBy] = useState(headCells[0].field);
  const [order, setOrder] = useState<"asc" | "desc">("asc");
  const [selectedRow, setSelectedRow] = useState<number | null>(null); // Use the appropriate type for your use case

  const handleSortRequest = (property: string) => {
    const isAsc = orderBy === property && order === "asc";
    setOrder(isAsc ? "desc" : "asc");
    setOrderBy(property);
  };

  const handleRowSelect = useCallback(
    index => {
      if (index === selectedRow) {
        setSelectedRow(null);
        onRowSelect(index);
      } else {
        setSelectedRow(index);
        onRowSelect(index);
      }
    },
    [selectedRow, setSelectedRow, onRowSelect]
  );
  return (
    <div className={classes.root}>
      <Paper className={classes.paper}>
        <TableContainer>
          <Table
            className={classes.table}
            aria-labelledby="tableTitle"
            size="medium"
            aria-label="enhanced table"
          >
            <TableHead>
              <TableRow className={classes.blockedDisplay}>
                <TableCell padding="checkbox" className={classes.radioCell} />
                {headCells.map(headCell => (
                  <TableCell
                    className={classes.tabHeadBg}
                    key={headCell.field}
                    align="left"
                    padding="default"
                  >
                    {headCell.field === sortField ? (
                      <TableSortLabel
                        className={classes.sortIcon}
                        active={orderBy === headCell.field}
                        direction={orderBy === headCell.field ? order : "asc"}
                        onClick={() => handleSortRequest(headCell.field)}
                      >
                        {headCell.headerName}
                      </TableSortLabel>
                    ) : (
                      <MyTypography variant="subtitle3">
                        {headCell.headerName}
                      </MyTypography>
                    )}
                  </TableCell>
                ))}
              </TableRow>
            </TableHead>
            <TableBody className={classes.bodyScroll}>
              {rows?.length > 0 &&
                rows
                  .sort((a, b) => {
                    const isAsc = order === "asc";
                    return isAsc
                      ? a[orderBy] > b[orderBy]
                        ? 1
                        : -1
                      : b[orderBy] > a[orderBy]
                      ? 1
                      : -1;
                  })

                  .map((row, index) => (
                    <TableRow
                      hover
                      tabIndex={-1}
                      key={index}
                      onClick={() => handleRowSelect(index)}
                      selected={selected === row.address}
                      className={classes.flexDisplay}
                    >
                      <TableCell
                        padding="checkbox"
                        className={classes.tabBodyPad}
                      >
                        <Radio checked={selected === row.address} />
                      </TableCell>
                      {headCells.map(cell => (
                        <TableCell
                          className={classes.noBorder}
                          key={cell.field}
                          component="th"
                          scope="row"
                          padding="default"
                        >
                          {row[cell.field]}
                        </TableCell>
                      ))}
                    </TableRow>
                  ))}
            </TableBody>
          </Table>
        </TableContainer>
      </Paper>
    </div>
  );
};

export default DataSortTable;
